import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AccountAdminTable from "./accountTableComp/AccountAdminTable";
import AccountTeamTable from "./accountTableComp/AccountTeamTable";
import ClientTeamTable from "./accountTableComp/ClientTeamTable";

const AccountTeamAndAdminsSection = ({
  WrapperComponent,
  cmsComponents,
  fetchClientTeamMemberSelectLabel,
  fetchAccountTeamMemberSelectLabel,
  fetchAccountAdminSelectLabel,
  onOpenClientTeamDialog,
  onOpenAccountTeamDialog,
  onOpenAccountAdminDialog,
  clientTeamTableData,
  setClientTeamTableData,
  accountTeamMemberTableData,
  setAccountTeamMemberTableData,
  accountAdminTableData,
  setAccountAdminTableData,
  rhfFormInstance,
  wasAdminEdited,
  setWasAdminEdited,
}) => {
  const showAccountAdminError =
    !!rhfFormInstance.formState.errors.accountAdmins &&
    (rhfFormInstance.formState.isSubmitted || wasAdminEdited);

  return (
    <>
      <WrapperComponent>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="h6"
            align="center"
            sx={{ fontWeight: "bolder" }}
          >
            {cmsComponents && cmsComponents["ClientAccounts.ClientTeamMembers"]?.Title}
          </Typography>
          <Button variant="outlined" size="small" onClick={onOpenClientTeamDialog}>
            {fetchClientTeamMemberSelectLabel}
          </Button>
        </Stack>
        <ClientTeamTable
          tableData={clientTeamTableData || []}
          setTableData={setClientTeamTableData}
        />
      </WrapperComponent>

      <br />

      <WrapperComponent>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="h6"
            align="center"
            sx={{ fontWeight: "bolder" }}
          >
            {cmsComponents && cmsComponents["ClientAccounts.AccountTeamMembers"]?.Title}
          </Typography>
          <Button variant="outlined" size="small" onClick={onOpenAccountTeamDialog}>
            {fetchAccountTeamMemberSelectLabel}
          </Button>
        </Stack>
        <AccountTeamTable
          tableData={accountTeamMemberTableData || []}
          setTableData={setAccountTeamMemberTableData}
          setWasAdminEdited={setWasAdminEdited}
        />
      </WrapperComponent>

      <br />

      <WrapperComponent
        sx={{
          border: showAccountAdminError ? "1px solid red" : undefined,
          borderRadius: 1,
          pb: 1,
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="h6"
            align="center"
            sx={{ fontWeight: "bolder" }}
          >
            {cmsComponents && cmsComponents["ClientAccounts.AccountAdmins"]?.Title}
          </Typography>
          <Button variant="outlined" size="small" onClick={onOpenAccountAdminDialog}>
            {fetchAccountAdminSelectLabel}
          </Button>
        </Stack>

        <AccountAdminTable
          tableData={accountAdminTableData || []}
          setTableData={setAccountAdminTableData}
          rhfFormInstance={rhfFormInstance}
          setWasAdminEdited={setWasAdminEdited}
        />

        {showAccountAdminError && (
          <Typography
            color="error"
            variant="caption"
            align="left"
            sx={{ px: 2, pt: 1 }}
          >
            {rhfFormInstance.formState.errors.accountAdmins.message}
          </Typography>
        )}
      </WrapperComponent>
    </>
  );
};

export default AccountTeamAndAdminsSection;
